import React from "react";
import { isIdentityView } from "../../../LiveDashboardModal/utils/viewTransform";

const tickStyle = {
  position: "absolute",
  backgroundColor: "#666",
};

// Under the editor's zoom the ticks mark where 0 / half / full metres of the
// floor actually are (the axis labels' positions), and only those inside the
// canvas are drawn. At zoom 1 (or with no viewport) it is the fixed edge
// markup below, unchanged.
const ProjectedTicks = ({ canvasSize, viewport }) => {
  const { left, top, width, height } = viewport.floorRect;
  const inside = (px, size) => px >= 0 && px <= size;
  const xs = [left, left + width / 2, left + width].filter((x) =>
    inside(x, canvasSize.width),
  );
  const ys = [top, top + height / 2, top + height].filter((y) =>
    inside(y, canvasSize.height),
  );
  return (
    <>
      {xs.map((x) => (
        <div
          key={`x-${x}`}
          style={{ ...tickStyle, bottom: 0, left: x, width: 1, height: 8 }}
        />
      ))}
      {ys.map((y) => (
        <div
          key={`y-${y}`}
          style={{ ...tickStyle, top: y, left: 0, width: 8, height: 1 }}
        />
      ))}
    </>
  );
};

const CanvasTickMarks = ({ canvasSize, viewport }) => {
  if (viewport && !isIdentityView(viewport)) {
    return <ProjectedTicks canvasSize={canvasSize} viewport={viewport} />;
  }
  return (
    <>
      {/* Bottom tick lines */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: 1,
          height: 8,
          backgroundColor: "#666",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: canvasSize.width / 2,
          width: 1,
          height: 8,
          backgroundColor: "#666",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: 1,
          height: 8,
          backgroundColor: "#666",
        }}
      />
      {/* Left tick lines */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 8,
          height: 1,
          backgroundColor: "#666",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: canvasSize.height / 2,
          left: 0,
          width: 8,
          height: 1,
          backgroundColor: "#666",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: 8,
          height: 1,
          backgroundColor: "#666",
        }}
      />
    </>
  );
};

export default CanvasTickMarks;

